// extracted by css-extract-rspack-plugin
export default {"container":"atF3bw9___container"};